import * as React from "react";

import emptyStateIcon from "assets/img/reports-new/report-empty-state.svg";
import { trackEmptyStateClicked } from "helpers/analytics-reports";
import { EmptyState } from "routes/reports/components";

import { LinkButton } from "./LinkButton";

const ScheduledReportEmptyState: React.FC = () => (
  <EmptyState
    icon={emptyStateIcon}
    title="No scheduled reports yet"
    description="Generate custom reports and have them emailed on a regular basis."
    button={
      <LinkButton href="/reports/generate-report" onClick={() => trackEmptyStateClicked("schedule report")}>
        Schedule report
      </LinkButton>
    }
  />
);

export default ScheduledReportEmptyState;
